import React from "react"

export default function Blog032() {
  return (
    <section>
    <article>
    <h2>32. 12-29-2022</h2>
          <h3>New Blog Setup!</h3>
          <p>
          <strong>Howdy Folks!</strong>
          <br /><br />
          Redesigning a blog page can be a challenging task, especially if you're not familiar with web development frameworks. However, with some planning and effort, it's possible to create a professional, user-friendly site that showcases your content and engages your readers.
          <br /><br />
For my blog page, I decided to use React.js, a popular JavaScript library for building user interfaces, and Tailwind, a CSS framework for quickly building custom designs. These tools allowed me to create a clean, modern design that would be easy to navigate and visually appealing.
<br /><br />
I started by organizing my content into cards, which are small, square blocks that display information such as the title, author, and a brief summary of each blog post. To create the cards, I used React components to define the layout and content, and styled them with Tailwind classes. This made it easy to customize the look and feel of the cards, and allowed me to quickly iterate on the design.
<br /><br />
One key feature of my redesigned blog page is the use of the "useNavigate" function, which allows users to easily navigate between different pages on the site. When a user clicks on a card, the function is triggered and takes them to the appropriate route, displaying the full blog post in a new page. This helps to keep the page clutter-free and makes it easier for users to find the content they're looking for.
<br /><br />
In addition to the cards, I also added a footer to the page, which is a duplicate of the header with some font changes and no nav button. The footer serves as a helpful reference for users, providing them with quick access to important information such as contact details and social media links.
<br /><br />
Overall, I'm really happy with the way my redesigned blog page turned out. It looks more professional and is much easier to navigate than my previous design. I hope you've enjoyed reading about my redesign process, and if you have any questions or comments, feel free to leave them in the comments section below. Thanks for reading!


<br /><br />
Sincerely,<br />
Eric Polley
<br />



         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="http://news.ericpolley.com/"
              title="BAHAGAFISH!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>BAHAGAFISH NEWS</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
